import React, { useState, useEffect } from "react";
import ReactIdSwiper from "react-id-swiper";

export default (props) => {
  // //console.log(props);
  var data = props.data;
  // Swiper instance
  const [swiper, updateSwiper] = useState(null);
  // Slides current index
  const [currentIndex, updateCurrentIndex] = useState(0);
  var elePagi = ".swiper-pagination";
  if (props.page == "home-banners") {
    elePagi = ".swiper-pagination.swiper-pagination-white";
  }
  var params = {};
  // Params definition
 (props.page == "dr-carousel-unit")
    params = {
      loop: true,
        slidesPerView: "auto",
        slidesPerView: 2.4,
        spaceBetween: 12,
         breakpoints: {
        767: {
          slidesPerView: 2.4,
          spaceBetween: 12
        },
      },
      getSwiper: updateSwiper // Get swiper instance callback
    }
  

  // Manipulate swiper from outside
  const goNext = () => {
    if (swiper !== null) {
      swiper.slideNext();
    }
  };

  const goPrev = () => {
    if (swiper !== null) {
      swiper.slidePrev();
    }
  };

  // Add eventlisteners for swiper after initializing
  useEffect(() => {
    if (swiper !== null) {
      swiper.on("slideChange", () => updateCurrentIndex(swiper.realIndex));
    }

    return () => {
      if (swiper !== null) {
        swiper.off("slideChange", () => updateCurrentIndex(swiper.realIndex));
      }
    };
  }, [swiper]);

  return (
    <div>
      <ReactIdSwiper {...params}>
        {data.map((item, idx) => (
          (props.page == "dr-carousel-unit" ?
            <div className="swiper-slide_doc_connect " key={idx}>
              <div className="consult_doctor_all_tools_bar">
                  <div className="consult_doctor_main_content"> 
                      <img src={item.symptomsImage} alt=""/>
                  </div>
                  <div className="docconect_consult_view">
                    <div className="consult_heading R13_42"> {item.symptomsText} </div> 
                    <div className="consult_para_text R12_9e"> {item.consultantType} </div>
                    <div className="consult_now_btn"> 
                      <button className="M11_white" type="button" tabIndex={0} aria-label="Consult now"> Consult now </button>
                    </div>
                  </div>
              </div>
            </div>
            :
            <div className="swiper-slide_feed" key={idx}>
              <img src="https://bbcdnlivemumbai.s3.ap-south-1.amazonaws.com/brainbees/community/memoryimages/1584339297p4706331.jpeg" alt="" />
            </div>
          )
        ))}
      </ReactIdSwiper>
      <div className="buttons buttons-list" style={{ display: "none" }}>
        <button id="prevSlide" className="button is-primary" onClick={goPrev} aria-label="Previous">
          Prev
        </button>
        <button id="nextSlide" className="button is-primary" onClick={goNext} aria-label="Next">
          Next
        </button>
      </div>
    </div>
  );
};
